import React from 'react';
import styled from 'styled-components';
import { isMeasureCohortFilter } from '../../../../../redux/slices/oldBuilder/utils';
import {
  CohortConditionIcon,
  IconWrapper,
  IndexedIcon,
  LetterIcon,
  PredictionCohortIcon,
  SvgIcon,
} from '../../../../Icon';
import { IRowMeta, RowType } from '../../../../../redux/slices/oldBuilder';
import { theme } from '../../../../../styles/theme';

interface IProps {
  rowMeta: IRowMeta;
  isActive?: boolean;
}

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

const TextContainer = styled.span`
  font-weight: 600;
  color: ${theme.colors.secondary900};
`;

export default ({ rowMeta, isActive }: IProps) => {
  const { rowType, rowIndex } = rowMeta;

  // A, B, C icons
  if (rowType === RowType.builderCohorts) {
    return <CohortConditionIcon conditionIndex={rowIndex} />;
  }

  // source/target icons
  if (rowType === RowType.predictionCohorts) {
    const cohortName = rowIndex === 0 ? 'Source Cohort' : 'Target Cohort';

    return (
      <IconContainer>
        <TextContainer>{cohortName}</TextContainer>
        <PredictionCohortIcon index={rowIndex} />
      </IconContainer>
    );
  }

  if (isMeasureCohortFilter(rowMeta)) {
    return <LetterIcon name="named-cohort" letter="M" isActive={true} />;
  }

  if (rowType === RowType.globalCohorts) {
    return (
      <IconWrapper>
        <SvgIcon isActive name="cohort-filter" height={16} width={16} />
      </IconWrapper>
    );
  }

  return (
    <IndexedIcon
      name="named-cohort"
      positiveIndex={rowIndex + 1}
      isActive={isActive || true}
    />
  );
};
